import { NavLink } from "react-router-dom";
import { Home, Film, Tv, Trophy, Newspaper } from "lucide-react";
import "./BottomNav.css";

function BottomNav() {
  return (
    <nav className="bottom-nav">
      <NavLink to="/" end className="nav-item">
        <Home className="nav-icon" />
        <span className="nav-label">Home</span>
      </NavLink>

      <NavLink to="/movies" className="nav-item">
        <Film className="nav-icon" />
        <span className="nav-label">Movies</span>
      </NavLink>

      <NavLink to="/webseries" className="nav-item">
        <Tv className="nav-icon" />
        <span className="nav-label">Series</span>
      </NavLink>
      
      <NavLink to="/shorts" className="nav-item">
      <Newspaper className="nav-icon" />
        <span className="nav-label">Shorts</span>
      </NavLink>


      {/* <NavLink to="/sports" className="nav-item">
        <Trophy className="nav-icon" />
        <span className="nav-label">Sports</span>
      </NavLink>

      <NavLink to="/news" className="nav-item">
        <Newspaper className="nav-icon" />
        <span className="nav-label">News</span>
      </NavLink> */}

    </nav>
  );
}

export default BottomNav;
